module.exports = __webpack_public_path__ + "media/smile-3.ed379697.mp3";